// extracted by mini-css-extract-plugin
export default {"row":"GjPhnchWarzeMriAacXz","cell":"w9mrH6KkZzyxP_Ws5M9m"};